export type MediaType = 'movie' | 'tv' | 'variety';

export type Region = '大陆' | '欧美' | '日韩' | '港台';

export interface Movie {
  id: string;
  title: string;
  type: MediaType;
  year: number;
  region: Region;
  genres: string[];
  director: string;
  actors: string[];
  rating: number;
  heat: number;
  poster: string;
  summary: string;
  /** 电视剧 / 综艺的总集数 */
  episodes?: number;
  /** 更新日期，用于「最新」排序 */
  updatedAt: string;
}

export interface HeroSlide {
  id: string;
  movieId: string;
  backdrop: string;
  kicker: string;
  headline: string;
  description: string;
}

export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  /** 分组标题 -> 影视 id 列表 */
  groups: { name: string; reason: string; movieIds: string[] }[];
}

export const mediaTypeLabels: Record<MediaType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

export const regionOptions: Region[] = ['大陆', '欧美', '日韩', '港台'];

export const genreOptions: string[] = [
  '动作', '爱情', '剧情', '科幻', '悬疑', '喜剧', '犯罪', '冒险', '奇幻', '动画', '战争', '历史', '武侠',
  '都市', '青春', '音乐', '真人秀', '竞技', '古装', '年代', '医疗', '生活', '美食',
];

export const yearRangeOptions: { label: string; min: number; max: number }[] = [
  { label: '2020后', min: 2020, max: 2100 },
  { label: '2010-2019', min: 2010, max: 2019 },
  { label: '2000-2009', min: 2000, max: 2009 },
  { label: '更早', min: 0, max: 1999 },
];